import React from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
  RichTextField,
  DateField,
  BooleanField,
  SelectField,
  ArrayField,
  Datagrid,
} from "react-admin";
import { Typography } from "@mui/material";
import { dateOptions, languageChoices, projectType } from "utils/options";
import CustomImage from "../Partials/CustomComponents/CustomImage";

const ShowProjects = () => {
  return (
    <Show title="Детайли за проект">
      <SimpleShowLayout>
        <SelectField
          label="Език"
          source="language"
          choices={languageChoices}
        />
        <DateField
          label="Начална дата"
          source="starting_on"
          locales={"bg"}
          options={dateOptions}
        />
        <DateField
          label="До дата"
          source="ending_on"
          locales={"bg"}
          options={dateOptions}
        />
        <DateField
          label="Дата на публикуване"
          source="started_on"
          locales={"bg"}
          options={dateOptions}
        />
        <SelectField
          label="Тип проект"
          source="project_type"
          choices={projectType}
          fullWidth
        />
        <TextField
          label="№ Проект"
          source="project_number"
          fullWidth
        />
        <TextField
          label="Програма"
          source="program"
          fullWidth
        />
        <TextField
          label="Заглавие на проекта"
          source="title"
        />
        <TextField
          label="Общ бюджет "
          source="common_budget"
          fullWidth
        />
        <TextField
          label="Бюджет на Български пощи"
          source="budget_оf_bulgarian_posts"
          fullWidth
        />
        <TextField
          label="Срок за изпълнение"
          source="deadline_for_implementation"
          fullWidth
        />
        <TextField
          label="Ръководител на проекта"
          source="project_manager"
          fullWidth
        />
        <TextField
          label="Партньори"
          source="partners"
          fullWidth
          multiline
        />
        <TextField
          label="Фонд"
          source="fund"
          fullWidth
        />
        <TextField
          label="Практиканти"
          source="participant"
          fullWidth
        />
        <BooleanField
          label="Скрита"
          source="is_hidden"
        />

        <RichTextField
          label="Съдържание"
          source="content"
        />
        <RichTextField
          label="Допълнителна информация"
          source="additional_information"
        />
        <CustomImage
          label={"Текуща снимка"}
          style={{
            maxHeight: "10rem",
            maxWidth: "100%",
            marginBottom: "2rem",
          }}
        />
        <Typography>Качени файлове</Typography>
        <ArrayField
          label=""
          source="project_files"
        >
          {" "}
          <Datagrid
            bulkActionButtons={false}
            empty={<Typography sx={{ marginBottom: "40px", fontSize: ".8rem" }}>Няма зададени</Typography>}
          >
            <TextField
              label="Име на файл"
              source="name"
            />
            <TextField
              label="Линк"
              source="url"
            />
          </Datagrid>
        </ArrayField>
      </SimpleShowLayout>
    </Show>
  );
};
export default ShowProjects;
